module.exports = __webpack_public_path__ + "static/media/DNA_step_2_Full.f02f2443.mp4";